import { useMutation } from 'react-query';
import { AuthedUser, UserBodyParams } from '@repo/types/user';
import { httpClient } from '../../../../utils/http/http-client';
import { useEffect, useState } from 'react';
import { getJwt, storeJwt } from '../../utils/store-jwt';

export const useAuthenticate = () => {
  const [isAuthenicated, setIsAuthenicated] = useState(Boolean(getJwt()));

  const { mutate, data, isLoading, isError, isSuccess } = useMutation({
    mutationKey: ['authenticate'],
    mutationFn: (params: UserBodyParams) =>
      httpClient.POST<UserBodyParams, AuthedUser>(`user/authenticate`, params),
    retry: false,
  });

  useEffect(() => {
    if (isSuccess) {
      storeJwt(data.jwt);
      setIsAuthenicated(true);
    }
  }, [data, isSuccess]);

  return {
    authenticate: mutate,
    isLoading,
    isError,
    isAuthenicated,
  };
};
